import React from 'react';

export default function SubtitleSlice(props) {
	const text = props.text;
	return (
		<div className="container theme-page-content-wrapper">
			<div className="row">
				<div className="col-12 heading-section no-margin ">
					<p className="body-copy">{text}</p>
				</div>
			</div>
		</div>
	);
}



// WEBPACK FOOTER //
// src/client/components/slices/SubtitleSlice.js